import React, { PureComponent } from 'react';
import localizedStr, { EN_US, SupportedLocale } from '../../core/util/localizedStr';
import { LEGAL_TOS_URL } from '../../constants/index';
import Link from '../Link';

type Props = {
  children?: React.ReactNode;
  className?: string;
  locale?: SupportedLocale;
};

export default class TermsOfService extends PureComponent<Props> {
  render() {
    return (
      <Link className={this.props.className} to={LEGAL_TOS_URL}>
        {this.props.children || localizedStr[this.props.locale || EN_US].TERMS_OF_SERVICE}
      </Link>
    );
  }
}
